import { oc } from '@orpc/contract';
import { setUserStatusInputSchema, tenantUserSchema } from '../schemas/users.schemas.js';
export const disableUserContract = oc
    .route({
    method: 'POST',
    path: '/users/{userId}/status',
    tags: ['Users'],
    summary: 'Disable or re-enable a membership; disabling ends the session on the next refresh',
})
    .input(setUserStatusInputSchema)
    .output(tenantUserSchema);
//# sourceMappingURL=disable-user.contract.js.map